import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { mediaSrc } from './services/mediaAssets';
import './firebase';
import store from './store';
import vuetify from './plugins/vuetify';
import './styles/global.scss'; // Adjust the path as necessary

Vue.config.productionTip = false;
Vue.filter('mediaSrc', mediaSrc);
store.dispatch('initializeAuth');

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
